// extracted by mini-css-extract-plugin
export default {"thresholds":"BundlePricing_thresholds__W4g+h","threshold":"BundlePricing_threshold__35eRG","savings":"BundlePricing_savings__Vlp3C","mixMatchMsg":"BundlePricing_mixMatchMsg__1v9Qv"};